<template>
  <layout-auth style="background: #f3f5f7 !important">
    <v-form>
      <v-container class="py-10">
        <v-row>
          <v-col>
            <h1 class="text-h4 font-weight-light py-5">
              {{ $t("invoices.cuentaAbono") }}
            </h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2
              :hidden="
                (model.codEcvEgc == '4' && model.indSitVal == 'N') ||
                (model.codEcvEgc == '6' && model.indSitVal == 'N')
              "
              class="text-h5 font-weight-light"
            >
              {{ $t("accounts.introduscaDatosRequeridosAltaCuentadeAbono2") }}
            </h2>

            <h2
              :hidden="
                (model.codEcvEgc == '4' && model.indSitVal == 'S') ||
                (model.codEcvEgc == '6' && model.indSitVal == 'S')
              "
              class="text-h5 font-weight-light"
            >
              {{ $t("accounts.sindescaragar") }}
            </h2>
          </v-col>
        </v-row>
        <v-row class="py-10">
          <v-col cols="12" sm="12" md="6" lg="6">
            <label>{{ $t("accounts.accountNumber") }}</label>
            <v-text-field
              :disabled="model.codEcvEgc === '6' || model.codEcvEgc === '4'"
              v-model="model.iban"
              dense
              outlined
              :color="entityConfig.primaryColor"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="2" lg="2">
            <label>{{ $t("accounts.bic") }}</label>
            <v-text-field
              :disabled="spainIban"
              v-model="model.bic"
              dense
              outlined
              :color="entityConfig.primaryColor"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12" lg="8">
            <label>{{ $t("accounts.description") }}</label>
            <v-text-field
              v-model="model.description"
              dense
              outlined
              :color="entityConfig.primaryColor"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="py-10">
          <v-col cols="12" sm="12" lg="12">
            <v-btn
              v-if="!confirmed"
              :disabled="disabledDocumen"
              :style="`color: ${entityConfig.secondaryColor}`"
              depressed
              :color="entityConfig.primaryColor"
              class="float-end m-2 v-btn-width-default"
              @click="edit_account"
            >
              {{ $t("login.aceptar") }}
            </v-btn>

            <v-btn
              v-else
              depressed
              @click="finalizar"
              :color="entityConfig.primaryColor"
              :style="`color: ${entityConfig.secondaryColor}`"
              class="float-end m-2 v-btn-width-default"
            >
              {{ $t("supplierData.finish") }}
            </v-btn>

            <v-btn
              v-if="!confirmed"
              :loading="isSelecting"
              @click="handleFileImport"
              depressed
              :color="entityConfig.primaryColor"
              :style="`color: ${entityConfig.secondaryColor}`"
              class="float-end m-2"
            >
              {{ $t("accounts.adjuntarDocumentacion") }}
            </v-btn>

            <input
              @change="onFileChanged"
              ref="uploader"
              class="d-none"
              type="file"
              accept="application/pdf,image/jpg,image/png,image/jpeg"
            />

            <v-btn
              :hidden="
                (model.codEcvEgc === '6' && model.indSitVal === 'N') ||
                (model.codEcvEgc === '4' && model.indSitVal === 'N')
              "
              depressed
              target="_blank"
              :href="entityConfig.titularidad"
              :color="entityConfig.primaryColor"
              :style="`color: ${entityConfig.secondaryColor}`"
              class="float-end m-2"
            >
              {{ $t("accounts.descargarVerificacionTituaridad") }}
            </v-btn>
          </v-col>
          <v-col><label class="float-end m-2">{{ $t("accounts.antiguedadPngJpejPDF") }}</label></v-col>
        </v-row>
        <overlay :visible="spinner" :opacity="1"></overlay>
      </v-container>
    </v-form>
  </layout-auth>
</template>

<script>
import LayoutAuth from "../../components/layouts/layout-auth.vue";

import Overlay from "../../components/layouts/overlay.vue";
import Api from "../../Services/index";

export default {
  components: {
    "layout-auth": LayoutAuth,
    Overlay,
  },
  data: () => ({
    userId: "",
    confirmed: false,
    userdata: {},
    form: {
      iban: "",
      description: "",
    },
    spinner: false,
    checkbox: true,
    model: { iban: "", description: "" },
    entityConfig: {},
    document: null,
    documentExt: "",
    isSelecting: false,
  }),

  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
    Api.defaults.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("authtoken");
    this.userdata = JSON.parse(sessionStorage.getItem("userData"));
    this.userId = this.userdata.supplierId.trim();

    let editAccount = JSON.parse(sessionStorage.getItem("vec"));
    if (editAccount) {
      this.model = editAccount;
    }
  },

  computed: {
    disabledDocumen() {
      return this.document === null;
    },
    spainIban() {
      return this.model.iban.startsWith("ES");
    },
  },

  methods: {
    handleFileImport() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      var status = "";
      if (
        (this.model.codEcvEgc == "4" && this.model.indSitVal == "S") ||
        (this.model.codEcvEgc == "6" && this.model.indSitVal == "S")
      ) {
        status = "|V";
      }

      var file = e.target.files[0],
        reader = new FileReader();

      this.documentExt = file.type.split("/")[1] + status;
      let that = this;
      reader.onloadend = function () {
        that.document = reader.result.replace(/^data:.+;base64,/, "");
      };

      reader.readAsDataURL(file);
    },

    finalizar() {
      this.$router.push({ path: "/cuentas-de-abono" });
    },
    async edit_account() {
      try {
        let message = "Su cuenta ha quedado pendiente de validación";
        this.spinner = true;
        const formData = new FormData();
        formData.append("iban", this.model.iban);
        formData.append("bic", this.model.bic);
        formData.append("description", this.model.description);
        formData.append("document", this.document);
        formData.append("ext", this.documentExt);
        Api.defaults.headers.common["Authorization"] =
          "Bearer " + sessionStorage.getItem("authtoken");
        const obj = Object.fromEntries(formData);
        await Api.put(`/proveedores/${this.userId}/cuentas-abono`, obj);
        this.spinner = false;
        this.confirmed = true;
        this.$toast.success(message);
        this.$router.push({ path: "/cuentas-de-abono" });

        sessionStorage.removeItem("vec");
      } catch (error) {
        this.$showError(this, error.response.data);
      } finally {
        this.spinner = false;
      }
    },
  },
};
</script>
